class WooCommerce {

    /**
     * @since 5.10.2
     * @method constructor
     */
    constructor() {
        // Run initialization
        this.init()
    }

    /**
     * Initialize the class.
     *
     * @method init
     * @since 5.10.2
     * @returns object The initialized map
     */
    init() {

        // Declare and initialize
        var imgToShow     = '';
        var variations    = $('.variations_form').data('product_variations');
        var primaryImage  = $('.primary-product-image img');
        var primaryThumb  = $('.primary-product-image-thumb img');
        var slideshow     = primaryImage.closest('.slideshow');
        var original      = primaryImage.attr('src');
        var originalThumb = primaryThumb.attr('src');
        var lookup        = {};
        var active        = {};

        // If there are no variations, bail out
        if (!variations)
            return;

        // Key our variations for quicker discovery
        variations.forEach((variation, index) => {

            // Pull the attributes
            let atts = variation.attributes;
            let key  = '';

            // Run through the attributes
            for (const [attrName, attrValue] of Object.entries(atts)) {

                // Build a usable string from our value
                let valueString = attrValue.replace(/\W/g, '');

                // Concatenate our key if we already started
                if (!!key)
                    key += '_';

                // Build up the key
                key += attrName + '_' + valueString;

            }

            // Add to our lookup table
            lookup[key] = variation;

        });

        // Wait for the variation change
        $('table.variations').on('change', 'select', function (e) {

            // Declare and initialize
            let form    = $(e.target).closest('form');
            let selects = form.find('select');
            let values  = selects.serialize();

            // Translate into a key
            let key = values.replace(/[=&]/g, '_')
                .replace(/[^0-9a-zA-Z_=&]/g, '');

            // If we do not have this attribute, bail out
            if (!(key in lookup)) {

                // Revert back to original
                primaryImage.attr('src', original).removeAttr('srcset');
                primaryThumb.attr('src', originalThumb).removeAttr('srcset');

                // Wait until the image loads
                primaryImage.one('load', () => {

                    // Reset our slider height
                    slideshow.find('.slick-slide').height('auto');
                    slideshow.find('.slick-list').height('auto');

                    // Go back to the first slide
                    slideshow.slick('setOption', '', '', true)
                        .slick('slickGoTo', 0);

                });

                // Get outta here
                return;
            }

            // Set the active image URL
            active = {...lookup[key]};

            // Get the active image
            let activeImage    = active.image || {};
            let activeImageUrl = activeImage.url || '';
            let activeThumb    = active.image || {};
            let activeThumbUrl = activeThumb.thumb_src || activeImageUrl;

            // If there is no URL, do nothing
            if (!activeImageUrl)
                return;

            // Swap out the image
            primaryImage.attr('src', activeImageUrl).removeAttr('srcset');
            primaryThumb.attr('src', activeThumbUrl).removeAttr('srcset');

            // Wait until the image loads
            primaryImage.one('load', () => {

                // Reset our slider height
                slideshow.find('.slick-slide').height('auto');
                slideshow.find('.slick-list').height('auto');

                // Go back to the first slide
                slideshow.slick('setOption', '', '', true)
                    .slick('slickGoTo', 0);

            });

        });

    }

}

export default WooCommerce;